import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-m', 'LetterM', [["path",{"d":"M6 20v-16l6 14l6 -14v16","key":"svg-0"}]]);